export default __webpack_public_path__ + "static/media/off-canvas.8bdb147b.png";